import { ref, shallowRef } from 'vue';
import Keycloak from 'keycloak-js';

const isReady = ref(false);
const isLogin = ref(false);
const token = ref<string | null>(null);
const client = shallowRef<Keycloak | null>(null);
let refreshTimer: number | undefined;
let initialized = false;
let initPromise: Promise<boolean> | null = null;

export function useKeycloak() {
  if (initialized) {
    return { isReady, isLogin, token, client };
  }

  initialized = true;

  const kc = new Keycloak({
    url: import.meta.env.VITE_KEYCLOAK_URL,
    realm: import.meta.env.VITE_KEYCLOAK_REALM,
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT,
  });

  client.value = kc;

  initPromise = kc.init({
    onLoad: 'login-required',
    checkLoginIframe: false,
  })
    .then((authenticated: boolean) => {
      if (window.location.hash) {
        window.history.replaceState(window.history.state, '', window.location.pathname);
      }

      if (authenticated) {
        token.value = kc.token ?? null;
        isReady.value = true;
        isLogin.value = true;

        refreshTimer = window.setInterval(() => {
          kc.updateToken(30)
            .then(() => {
              token.value = kc.token ?? null;
            })
            .catch(() => kc.login());
        }, 30000);
      } else {
        kc.login();
      }
      return authenticated;
    })
    .catch(() => {
      isReady.value = true;
      isLogin.value = false;
      token.value = null;
      return false
    });

  return { isReady, isLogin, token, client };
}


export function cleanupKeycloak() {
  if (refreshTimer) {
    clearInterval(refreshTimer);
    refreshTimer = undefined;
  }
}

export function logout() {
  cleanupKeycloak();
  
  if (client.value) {
    client.value.logout({ redirectUri: window.location.origin });
  } else {
    window.location.href = '/';
  }
}

export async function waitForKeycloakReady() {
  console.log('init keycloak');
  const { isReady } = useKeycloak();
  if (isReady.value) return;
  await initPromise;
}